import script from "./CookiePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CookiePanel.vue?vue&type=script&setup=true&lang=js"

import "./CookiePanel.vue?vue&type=style&index=0&id=4d09fb83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d09fb83"]])

export default __exports__